import { NoResultsBold } from 'src/views/directory/styled/NoResultsFound.styled'
import styled, { css } from 'styled-components'

export const CounterContainer = styled.div`
  ${({ theme }) => {
    switch (theme.template) {
      case 'template-4':
        return css`
          display: block;
          grid-column: 1 / span 2;
          grid-row: 2;
          border-top: 1px solid #ebeff5;
          padding-top: 0.75rem;
          margin-top: 1rem;

          @media ${theme.mediaQueries.mobile} {
            border-top: none;
          }
        `
      default:
        return {}
    }
  }}
`

export const SrcNormalText = styled(NoResultsBold)`
  font-weight: normal;
`
